import React from "react"
import { makeStyles, Box } from "@material-ui/core"

const useStyles = makeStyles(() => ({
  root: {
    fontSize: 14,
    fontWeight: "600",
    textAlign: "center",
    opacity: "0.5",
  },
}))

const NoItemsMessage = ({ children, className = "", p = 2, ...rest }) => {
  const classes = useStyles()

  return (
    <Box
      className={`${classes.root} ${className}`}
      display="flex"
      p={p}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      {...rest}
    >
      {children}
    </Box>
  )
}

export { NoItemsMessage }
